import { Heart } from '@phosphor-icons/react';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import { cn } from '@/lib/utils';

interface LoveProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  doAnimation?: boolean;
}

export function Love({ className, children, doAnimation = false, ...props }: LoveProps) {
  return (
    <div className={cn('relative', className)} {...props}>
      <AnimatePresence>
        {doAnimation && (
          <>
            {Array.from({ length: 8 }).map((_, i) => (
              <motion.div
                key={i}
                className="absolute top-1/2 left-1/2 origin-center pointer-events-none"
                initial={{ opacity: 0, scale: 0.3, x: 0, y: 0 }}
                animate={{
                  opacity: [0, 1, 1, 0],
                  scale: [0.3, 1, 1, 0],
                  x: [0, Math.cos(i * (Math.PI / 4)) * 30],
                  y: [0, Math.sin(i * (Math.PI / 4)) * 30],
                  rotate: [0, i % 2 ? 45 : -45],
                }}
                transition={{
                  duration: 1.2,
                  ease: [0.4, 0, 0.2, 1],
                  times: [0, 0.3, 0.7, 1],
                  delay: i * 0.1,
                }}
              >
                <Heart
                  className="size-4 text-rose-500"
                  style={{
                    filter: 'drop-shadow(0 0 3px rgba(255, 75, 110, 0.8))',
                    strokeWidth: 2.5,
                  }}
                />
              </motion.div>
            ))}
            <motion.div
              className="absolute inset-0 rounded-full bg-primary pointer-events-none"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{
                opacity: [0, 0.15, 0.15, 0],
                scale: [0.8, 1.8, 1.8, 2],
              }}
              transition={{
                duration: 1.2,
                ease: 'easeOut',
                times: [0, 0.3, 0.7, 1],
              }}
            />
          </>
        )}
      </AnimatePresence>
      {children}
    </div>
  );
}
